import * as React from "react";
export class FormSwitch extends React.Component{
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    needToRender(){
        if(!this.props.WithCVEnabled && !this.props.WithoutCVEnabled){
            this.props.setFastCV();
        } else if(!this.props.WithCVEnabled && !this.props.FastCVEnabled){
            this.props.setBuildCV();
        } else if(!this.props.WithoutCVEnabled && !this.props.FastCVEnabled){
            this.props.setOwnCV();
        }
        return true;
    }

    columnClass(){
        if(this.props.WithCVEnabled && this.props.WithoutCVEnabled && this.props.FastCVEnabled){
            return "col-lg-4";
        }
        return "col-lg-6";
    }

    withMarginClass(){
        return (
            this.columnClass() + " mb-3 mb-md-4 mb-lg-0"
        )
    }

    renderWithCV(){
        if(!this.props.WithCVEnabled){
            return null;
        }
        return (
            <div className={this.withMarginClass()} onClick={this.props.setOwnCV}>
                <div className="switch__card rounded-md text-center">
                    <div className="card__content">
                        <img src="resources/themes/fritz/images/own_cv_white.png" alt={this.props.WithCVTitle} className="mt-4 mt-md-5 white"/>
                        <h3 className="mt-3 mt-md-4 mt-lg-5 mb-2 mb-md-3 bold">
                            {this.props.WithCVTitle}
                        </h3>
                        <p className="font_16 subtitle">
                            {this.props.WithCVSubTitle}
                        </p>
                        <p className="font_16">
                            {this.props.WithCVContent}
                        </p>
                        <button className="btn btn-secondary">
                            Auswählen
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    renderWithoutCV(){
        if(!this.props.WithoutCVEnabled){
            return null;
        }
        return (
            <div className={this.withMarginClass()} onClick={this.props.setBuildCV}>
                <div className="switch__card rounded-md text-center">
                    <div className="card__content">
                        <img src="resources/themes/fritz/images/build_cv_white.png" alt={this.props.WithoutCVTitle} className="mt-4 mt-md-5 white"/>
                        <h3 className="mt-3 mt-md-4 mt-lg-5 mb-2 mb-md-3 bold">
                            {this.props.WithoutCVTitle}
                        </h3>
                        <p className="font_16 subtitle">
                            {this.props.WithoutCVSubTitle}
                        </p>
                        <p className="font_16">
                            {this.props.WithoutCVContent}
                        </p>
                        <button className="btn btn-secondary">
                            Auswählen
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    renderFastCV(){
        if(!this.props.FastCVEnabled){
            return null;
        }
        return (
            <div className={this.columnClass()} onClick={this.props.setFastCV}>
                <div className="switch__card rounded-md text-center">
                    <div className="card__content">
                        <img src="resources/themes/fritz/images/ruckzuck-bewerbung-icon-weiss.png" alt={this.props.FastCVTitle} className="mt-4 mt-md-5 white"/>
                        <h3 className="mt-3 mt-md-4 mt-lg-5 mb-2 mb-md-3 bold">
                            {this.props.FastCVTitle}
                        </h3>
                        <p className="font_16 subtitle">
                            {this.props.FastCVSubTitle}
                        </p>
                        <p className="font_16">
                            {this.props.FastCVContent}
                        </p>
                        <button className="btn btn-secondary">
                            Auswählen
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    equalHeightCards(){
        setInterval(() => {
            if(window.innerWidth >= 992) {
                let switches = document.querySelectorAll('.switch__card');
                let max_height = 0;
                switches.forEach(function (switch_card) {
                    if (switch_card.offsetHeight > max_height) {
                        max_height = switch_card.offsetHeight;
                    }
                });
                if (max_height > 0) {
                    switches.forEach(function (switch_card) {
                        switch_card.style.height = max_height + "px";
                    });
                }
            }
        }, 100);
        /*var cards = document.getElementsByClassName("switch__card");
        var maxHeight = 0;
        for(var i = 0; i < cards.length; i++){
            if(cards[i].clientHeight > maxHeight){
                maxHeight = cards[i].clientHeight;
            }
        }
        for(var i = 0; i < cards.length; i++){
            cards[i].style.height = maxHeight + "px";
        }*/
    }

    componentDidMount() {
        this.equalHeightCards();
    }

    render(){
        if(this.needToRender()){
            return(
                <div className="row">
                    {this.renderWithCV()}
                    {this.renderWithoutCV()}
                    {this.renderFastCV()}
                </div>
            )
        }
    }
}
export default FormSwitch;
